import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a1a', color: '#fff', flexDirection: 'column', gap: 16, padding: 24, textAlign: 'center' }}>
          <div style={{ fontSize: 48 }}>🌙</div>
          <h2 style={{ fontSize: 20, fontWeight: 700 }}>페이지를 불러오지 못했습니다</h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14 }}>
            새로고침하면 해결됩니다.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '10px 28px', borderRadius: 999, background: '#7c3aed', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}
          >
            새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
